export default __webpack_public_path__ + "static/media/guide_01.f04af462.md";